export default function UnitsFlooredDetailsItem({text, metric, metricColor, dataTestId }) {
  return(
    <div className="mb-2 ml-2 flex items-center" data-testid={dataTestId}>
      <div className={`${metricColor} mr-1`}>{metric}</div>
      <div>{text}</div>
    </div>
  )
}